import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';

export const PrivacyPage = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <Header />
            <main className="flex-grow pt-16">
                <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
                    <p className="text-gray-600 mb-4">Last Updated: {new Date().toLocaleDateString()}</p>
                    
                    <div className="prose prose-blue max-w-none space-y-8">
                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">Information We Collect</h2>
                            <ul className="list-disc pl-6 text-gray-600 space-y-2">
                                <li>Account information (email, name)</li>
                                <li>Subscription details you provide</li>
                                <li>Usage data and preferences</li>
                                <li>Device and browser information</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">How We Use Your Data</h2>
                            <ul className="list-disc pl-6 text-gray-600 space-y-2">
                                <li>To provide and improve our subscription tracking service</li>
                                <li>To send renewal reminders and important notifications</li>
                                <li>To generate spending insights and analytics</li>
                                <li>To maintain and secure your account</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">Data Security</h2>
                            <p className="text-gray-600">
                                We use industry-standard security measures to protect your data. Your subscription information is encrypted and stored securely. We never share your personal information with third parties without your explicit consent.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">Your Rights</h2>
                            <p className="text-gray-600">
                                You have the right to access, modify, or delete your personal data at any time. You can also request a copy of your data or opt out of non-essential data collection through your account settings.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">Children's Privacy</h2>
                            <p className="text-gray-600">
                                Our service is not directed to children under 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we can take necessary actions.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">Changes to This Policy</h2>
                            <p className="text-gray-600">
                                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">Contact Us</h2>
                            <p className="text-gray-600">
                                If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at:
                            </p>
                            <ul className="list-disc pl-6 text-gray-600 space-y-2">
                                <li>Email: support@keepitsorted.com</li>
                                <li>Website: www.keepitsorted.com</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">Compliance</h2>
                            <p className="text-gray-600">
                                Keep It Sorted complies with:
                            </p>
                            <ul className="list-disc pl-6 text-gray-600 space-y-2">
                                <li>GDPR (General Data Protection Regulation)</li>
                                <li>Google Play Store Privacy Requirements</li>
                                <li>Applicable data protection laws and regulations</li>
                            </ul>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}; 